// Récapitulatif d'un bon de remise (lien email + espace Prérec).
const TYPE_LABELS = {
    initial: "Remise initiale",
    complementary: "Remise complémentaire",
    return: "Restitution",
    regularization: "Régularisation",
};

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "long", timeStyle: "short" }) : "");

export default function NoteSummaryCard({ note }) {
    return (
        <div className="space-y-3" data-testid={`note-summary-${note.id}`}>
            <div className="flex items-center justify-between gap-2">
                <span className="text-[11px] font-black uppercase tracking-widest text-shariti-orange">
                    {TYPE_LABELS[note.type] || "Bon de remise"} · {note.number}
                </span>
                <span className="text-[11px] text-slate-400">{fmtDate(note.created_at)}</span>
            </div>
            <ul className="divide-y divide-shariti-cream rounded-2xl border border-shariti-gray bg-white">
                {note.items.map((it, i) => (
                    <li key={i} className="flex items-center justify-between px-4 py-2.5 text-sm">
                        <span className="font-bold text-slate-800">
                            {it.name}
                            {it.size && <span className="ml-1 text-xs text-slate-400">· {it.size}</span>}
                            {it.serial_number && <span className="ml-1 text-[10px] font-mono text-slate-400">#{it.serial_number}</span>}
                        </span>
                        <span className="text-slate-500 font-mono text-xs">× {it.quantity}</span>
                    </li>
                ))}
            </ul>
            <div className="flex items-center justify-between rounded-2xl bg-shariti-black text-white px-4 py-3">
                <span className="text-xs font-bold">Valeur totale</span>
                <span className="text-lg font-black text-shariti-orange" data-testid="note-summary-total">
                    {Number(note.total_value_eur || 0).toFixed(2)} €
                </span>
            </div>
            {note.deliverer_name && (
                <p className="text-xs text-slate-500">
                    Remis par <strong>{note.deliverer_name}</strong>
                    {note.deliverer_signed_at && <> · signé le {fmtDate(note.deliverer_signed_at)}</>}
                </p>
            )}
            {note.notes && <p className="text-xs text-slate-500 italic">« {note.notes} »</p>}
        </div>
    );
}
